
export const HeroOne = {
  sm_text: 'Uma boa',
  shape_text: 'Redação',
  title: 'se faz com correção de verdade',
  subtitle: "Venha ser #teamzáttera",
  btn_text: 'Conhecer os cursos',
  hero_img: '/assets/img/Capa-01.png',
  hero_sm_img: '/assets/img/Capa-02.png',
  hero__quote: 'Comece hoje',
  hero__quote_2: 'o seu curso',
}


export const hero_two = {
  title:<>Launch your <br /> Own</>,
  img:'/assets/img/Capa-02.png',
  shape_text:'online',
  title_2:'learning Platform',
  subtitle:'Unlimited access to all 60+ instructors.',
  sm_text:'2 passes (with access to all classes) for $240',
  hero_thumb_title:'Congratulations',
  hero_thumb_text:'Your admission completed',
  hero_thumb_number:450,
  hero_thumb_text_2:'Assisted Student',
  hero_thumb_title_2:'User Experience Class',
  hero_thumb_text_3:'Tomorrow is our',
}


export const hero_slider_data = [
  {
    bg_img:'/assets/img/slider/slider-4.jpg',
    sm_title:'Learn & Achieve',
    title_b_s:'Find the right Online',
    shape_text:'tutor',
    title_a_s:'for you.',
    text:"Meet university,and cultural institutions, who'll share their experience.",
    btn_text:'Ready to get Started?'
  },
  {
    bg_img:'/assets/img/slider/slider-1.jpg',
    sm_title:'Learn & Achieve',
    title_b_s:'Fundamentals of music',
    shape_text:'theory',
    title_a_s:'Learn',
    text:"Meet university,and cultural institutions, who'll share their experience.",
    btn_text:'Ready to get Started?'
  },
  {
    bg_img:'/assets/img/slider/slider-2.jpg',
    sm_title:'Learn & Achieve',
    title_b_s:'Become a product',
    shape_text:'Manager',
    title_a_s:'& Learn.',
    text:"Meet university,and cultural institutions, who'll share their experience.",
    btn_text:'Ready to get Started?'
  },
  {
    bg_img:'/assets/img/slider/slider-3.jpg',
    sm_title:'Learn & Achieve',
    title_b_s:'Launch your',
    shape_text:'Online',
    title_a_s:'Learning Platform.',
    text:"Meet university,and cultural institutions, who'll share their experience.",
    btn_text:'Ready to get Started?'
  },
]

export const hero_slider_nav = [
  {
    id: 1,
    img: '/assets/img/slider/nav/slider-nav-4.jpg',
    title: "6 Courses",
    subtitle: "Programming Languages",
    bgColor: "orange-bg",
  },
  {
    id: 2,
    img: '/assets/img/slider/nav/slider-nav-1.jpg',
    title: "4 Courses",
    subtitle: "Idea Discussion",
    bgColor: "blue-bg",
  },
  {
    id: 3,
    img: '/assets/img/slider/nav/slider-nav-2.jpg',
    title: "8 Courses",
    subtitle: "Web Development",
    bgColor: "pink-bg",
  },
  {
    id: 4,
    img: '/assets/img/slider/nav/slider-nav-3.jpg',
    title: "9 Courses",
    subtitle: "System Administration",
    bgColor: "green-bg",
  }
]